export const AUTH_KEY = 'crossfactory-user';
export const BRANCH_KEY = 'crossfactory-branch-id';
export const LAST_ACCESSED_BRANCH_KEY = 'crossfactory-last-branch';
